import { Pipe, PipeTransform } from '@angular/core';
import { WrapPanelWidth } from '@fleet-beat/wrap-panel';

@Pipe({
  name: 'wrapPanelWidth',
})
export class WrapPanelWidthPipe implements PipeTransform {
  transform(width: string | WrapPanelWidth | undefined, screen: 'md' | 'lg' | 'sm' | 'xs'): string {
    if (!width) {
      return '100%';
    }
    if (typeof width === 'string') {
      return width;
    }
    const config: WrapPanelWidth = width as WrapPanelWidth;
    return config[screen] || config.md || '100%';
  }
}
